import Vue from 'vue'
import Download from 'downloadjs'

Object.defineProperty(Vue.prototype, '$download', { value: Download })
